import { createSelector } from 'reselect'

export default (reducerName) => {
  const getData = state => state[reducerName].data
  const getTimestamp = state => state[reducerName].ts
  const getError = state => state[reducerName].error
  const isPending = state => state[reducerName].isPending
  const isComplete = state => state[reducerName].isComplete
  const isError = state => state[reducerName].isError

  return createSelector(
    getData,
    getTimestamp,
    getError,
    isPending,
    isComplete,
    isError,
    (data, ts, error, isPending, isComplete, isError) => {
      return {
        ts,
        data,
        error,
        isPending,
        isComplete,
        isError
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/store/utils/asyncSelector.js